const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicios(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3436 660",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 372.471,
    width: 3357.975,
    height: 55.704,
    style: {
      fill: "#127475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3298.718,329.778c38.963,0 70.546,31.583 70.546,70.546c0,38.962 -31.583,70.55 -70.546,70.55c-38.963,0 -70.546,-31.588 -70.546,-70.55c0,-38.963 31.583,-70.546 70.546,-70.546",
    style: {
      fill: "#f5dfbb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1888.016,237c40.5,0 71.7,-28.2 71.7,-70.8c0,-75 -95.7,-65.1 -95.7,-106.2c0,-13.5 10.2,-23.4 25.2,-23.4c13.8,0 23.4,8.4 26.7,22.8l35.1,-16.2c-8.7,-25.8 -32.7,-43.2 -62.7,-43.2c-34.8,0 -63,23.1 -63,61.2c0,70.2 95.4,58.2 95.4,104.4c0,18.6 -13.5,32.7 -33.9,32.7c-18.3,0 -33.3,-11.4 -38.4,-30.3l-35.4,15.9c9.3,30.9 39,53.1 75,53.1Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137.316,156.9c-0.6,-46.2 -34.2,-77.1 -77.7,-77.1c-46.2,0 -79.8,34.8 -79.8,78.6c0,43.8 33,78.6 81,78.6c31.8,0 57.3,-15.6 69.6,-40.5l-31.2,-12.9c-8.1,14.1 -22.8,21.9 -38.7,21.9c-22.2,0 -39.6,-15.6 -42.6,-40.2l119.1,0l0.3,-8.4Zm-77.4,-46.2c17.7,0 29.7,9.6 36,24.9l-74.1,0c6.6,-15.3 19.8,-24.9 38.1,-24.9Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2252.816,118.2l0,-38.1c-1.8,-0.3 -3.6,-0.3 -5.4,-0.3c-19.2,0 -31.8,9 -40.8,24.3l0,-21.3l-38.7,0l0,151.2l38.7,0l0,-66.9c0,-44.1 23.1,-53.4 46.2,-48.9Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2348.516,240l79.2,-157.2l-41.7,0l-37.5,85.2l-37.5,-85.2l-41.7,0l79.2,157.2Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2465.816,56.1c12.6,0 22.8,-9.9 22.8,-22.5c0,-12.6 -10.2,-22.5 -22.8,-22.5c-12.3,0 -22.8,9.9 -22.8,22.5c0,12.6 10.5,22.5 22.8,22.5Zm-19.2,177.9l38.4,0l0,-151.2l-38.4,0l0,151.2Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2596.316,237c11.4,0 22.5,-2.4 32.1,-6.6l0,-43.5c-7.5,8.7 -18.9,14.4 -32.1,14.4c-24.6,0 -42.6,-18.9 -42.6,-42.9c0,-24 18,-43.2 42.6,-43.2c13.2,0 24.6,5.7 32.1,14.7l0,-43.5c-9.6,-4.2 -20.7,-6.6 -32.1,-6.6c-45.6,0 -80.1,34.8 -80.1,78.6c0,43.8 34.5,78.6 80.1,78.6Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2683.016,56.1c12.6,0 22.8,-9.9 22.8,-22.5c0,-12.6 -10.2,-22.5 -22.8,-22.5c-12.3,0 -22.8,9.9 -22.8,22.5c0,12.6 10.5,22.5 22.8,22.5Zm-19.2,177.9l38.4,0l0,-151.2l-38.4,0l0,151.2Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2813.516,237c45,0 79.8,-34.8 79.8,-78.6c0,-43.8 -34.8,-78.6 -79.8,-78.6c-45.6,0 -80.1,34.8 -80.1,78.6c0,43.8 34.5,78.6 80.1,78.6Zm0,-36c-24,0 -42.9,-18.9 -42.9,-42.6c0,-23.7 18.9,-42.3 42.9,-42.3c23.1,0 42,18.6 42,42.3c0,23.7 -18.9,42.6 -42,42.6Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2968.616,237c33,0 56.7,-16.8 56.7,-47.4c0,-30.3 -22.8,-40.5 -45.3,-48c-17.7,-5.7 -28.5,-8.7 -28.5,-18.9c0,-7.8 6.3,-12.9 15.9,-12.9c10.2,0 21.6,6 30.3,14.7l22.8,-23.1c-11.7,-12.9 -30,-21.6 -51.9,-21.6c-29.1,0 -55.5,15.6 -55.5,46.2c0,26.4 19.8,36.9 43.2,45.3c18,6.3 30.3,9 30.3,19.5c0,8.1 -7.2,14.4 -19.2,14.4c-11.7,0 -25.8,-6.6 -36.3,-17.4l-21.9,26.7c12,12 33.3,22.5 59.4,22.5Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1845.319,625.054l19.5,0l0,-42.75l23.55,0c20.1,0 36.3,-13.2 36.3,-36.45c0,-23.1 -16.35,-36.3 -36.3,-36.3l-43.05,0l0,115.5Zm19.5,-62.25l0,-33.75l23.55,0c9.3,0 16.8,6 16.8,16.8c0,10.95 -7.5,16.95 -16.8,16.95l-23.55,0Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964.419,626.554c11.25,0 19.8,-4.2 25.5,-11.25l0.45,9.75l18.15,0l0,-75.6l-19.5,0l0,8.55c-5.55,-6.45 -13.8,-10.35 -24.6,-10.35c-20.4,0 -37.35,17.55 -37.35,39.45c0,22.05 16.95,39.45 37.35,39.45Zm3.75,-17.7c-12.15,0 -21.6,-9.75 -21.6,-21.75c0,-12 9.45,-21.6 21.6,-21.6c12,0 21.45,9.6 21.45,21.6c0,12 -9.45,21.75 -21.45,21.75Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2071.369,567.154l0,-19.05c-0.9,-0.15 -1.8,-0.15 -2.7,-0.15c-9.6,0 -15.9,4.5 -20.4,12.15l0,-10.65l-19.35,0l0,75.6l19.35,0l0,-33.45c0,-22.05 11.55,-26.7 23.1,-24.45Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2115.469,626.554c11.25,0 19.8,-4.2 25.5,-11.25l0.45,9.75l18.15,0l0,-75.6l-19.5,0l0,8.55c-5.55,-6.45 -13.8,-10.35 -24.6,-10.35c-20.4,0 -37.35,17.55 -37.35,39.45c0,22.05 16.95,39.45 37.35,39.45Zm3.75,-17.7c-12.15,0 -21.6,-9.75 -21.6,-21.75c0,-12 9.45,-21.6 21.6,-21.6c12,0 21.45,9.6 21.45,21.6c0,12 -9.45,21.75 -21.45,21.75Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2295.919,586.504c-0.3,-23.1 -17.1,-38.55 -38.85,-38.55c-23.1,0 -39.9,17.4 -39.9,39.3c0,21.9 16.5,39.3 40.5,39.3c15.9,0 28.65,-7.8 34.8,-20.25l-15.6,-6.45c-4.05,7.05 -11.4,10.95 -19.35,10.95c-11.1,0 -19.8,-7.8 -21.3,-20.1l59.55,0l0.15,-4.2Zm-38.7,-23.1c8.85,0 14.85,4.8 18,12.45l-37.05,0c3.3,-7.65 9.9,-12.45 19.05,-12.45Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2311.219,625.054l19.5,0l0,-45.45c0,-7.8 4.95,-14.25 12.75,-14.25c7.65,0 12.9,5.85 12.9,13.35l0,46.35l19.5,0l0,-45.45c0,-7.8 5.1,-14.25 13.05,-14.25c7.35,0 12.6,5.85 12.6,13.35l0,46.35l19.5,0l0,-47.85c0,-16.5 -11.85,-29.25 -27.9,-29.25c-9.75,0 -17.55,4.5 -22.5,11.85c-5.25,-7.35 -13.05,-11.85 -21.6,-11.85c-7.35,0 -13.8,3.45 -18.3,9l0,-7.5l-19.5,0l0,75.6Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2439.169,659.554l19.5,0l0,-42.6c6,6 14.1,9.6 24,9.6c20.4,0 37.2,-17.4 37.2,-39.3c0,-21.9 -16.8,-39.3 -37.2,-39.3c-9.9,0 -18,3.6 -24,9.6l0,-8.1l-19.5,0l0,110.1Zm39.9,-50.7c-11.85,0 -21.6,-9.6 -21.6,-21.6c0,-12 9.75,-21.6 21.6,-21.6c11.85,0 21.45,9.6 21.45,21.6c0,12 -9.6,21.6 -21.45,21.6Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2577.619,567.154l0,-19.05c-0.9,-0.15 -1.8,-0.15 -2.7,-0.15c-9.6,0 -15.9,4.5 -20.4,12.15l0,-10.65l-19.35,0l0,75.6l19.35,0l0,-33.45c0,-22.05 11.55,-26.7 23.1,-24.45Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2663.119,586.504c-0.3,-23.1 -17.1,-38.55 -38.85,-38.55c-23.1,0 -39.9,17.4 -39.9,39.3c0,21.9 16.5,39.3 40.5,39.3c15.9,0 28.65,-7.8 34.8,-20.25l-15.6,-6.45c-4.05,7.05 -11.4,10.95 -19.35,10.95c-11.1,0 -19.8,-7.8 -21.3,-20.1l59.55,0l0.15,-4.2Zm-38.7,-23.1c8.85,0 14.85,4.8 18,12.45l-37.05,0c3.3,-7.65 9.9,-12.45 19.05,-12.45Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700.769,626.554c16.5,0 28.35,-8.4 28.35,-23.7c0,-15.15 -11.4,-20.25 -22.65,-24c-8.85,-2.85 -14.25,-4.35 -14.25,-9.45c0,-3.9 3.15,-6.45 7.95,-6.45c5.1,0 10.8,3 15.15,7.35l11.4,-11.55c-5.85,-6.45 -15,-10.8 -25.95,-10.8c-14.55,0 -27.75,7.8 -27.75,23.1c0,13.2 9.9,18.45 21.6,22.65c9,3.15 15.15,4.5 15.15,9.75c0,4.05 -3.6,7.2 -9.6,7.2c-5.85,0 -12.9,-3.3 -18.15,-8.7l-10.95,13.35c6,6 16.65,11.25 29.7,11.25Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775.919,626.554c11.25,0 19.8,-4.2 25.5,-11.25l0.45,9.75l18.15,0l0,-75.6l-19.5,0l0,8.55c-5.55,-6.45 -13.8,-10.35 -24.6,-10.35c-20.4,0 -37.35,17.55 -37.35,39.45c0,22.05 16.95,39.45 37.35,39.45Zm3.75,-17.7c-12.15,0 -21.6,-9.75 -21.6,-21.75c0,-12 9.45,-21.6 21.6,-21.6c12,0 21.45,9.6 21.45,21.6c0,12 -9.45,21.75 -21.45,21.75Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2864.269,626.554c16.5,0 28.35,-8.4 28.35,-23.7c0,-15.15 -11.4,-20.25 -22.65,-24c-8.85,-2.85 -14.25,-4.35 -14.25,-9.45c0,-3.9 3.15,-6.45 7.95,-6.45c5.1,0 10.8,3 15.15,7.35l11.4,-11.55c-5.85,-6.45 -15,-10.8 -25.95,-10.8c-14.55,0 -27.75,7.8 -27.75,23.1c0,13.2 9.9,18.45 21.6,22.65c9,3.15 15.15,4.5 15.15,9.75c0,4.05 -3.6,7.2 -9.6,7.2c-5.85,0 -12.9,-3.3 -18.15,-8.7l-10.95,13.35c6,6 16.65,11.25 29.7,11.25Z",
    style: {
      fill: "#127475",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3298.718,504.438c57.4,0 104.112,-46.696 104.112,-104.112c0,-57.413 -46.696,-104.112 -104.112,-104.112c-57.417,0 -104.112,46.7 -104.112,104.112c0,57.417 46.696,104.112 104.112,104.112m0,-241.104c75.537,0 136.996,61.458 136.996,136.992c0,75.538 -61.458,136.996 -136.996,136.996c-75.537,0 -136.992,-61.458 -136.992,-136.996c0,-75.533 61.454,-136.992 136.992,-136.992",
    style: {
      fill: "#f5dfbb",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicios);
export default __webpack_public_path__ + "static/media/servicios.e2b766dda49a2483be1b362a15a69c87.svg";
export { ForwardRef as ReactComponent };